import { searchGroupAgreements } from "../../../../actions/CarrierAgreementMgmt/Agreements";
import { useMutation } from "react-query";

const useGroupSearchAgreements = () => {
  return useMutation(searchGroupAgreements);
};

export default useGroupSearchAgreements;
